import { InlineText } from '@ardoq/typography';
import { OptionContainer } from './atoms';
import { WorkspaceWithFolderPath as WorkspaceWithFolderPathType } from './types';
import { Breadcrumbs2 } from '@ardoq/basic-components';

export const WorkspaceWithFolderPath = ({
  name,
  folderPath,
}: WorkspaceWithFolderPathType) => (
  <OptionContainer>
    <InlineText variant="text2">{name}</InlineText>
    {folderPath.length > 0 && (
      <InlineText variant="caption" color="textSubtle">
        <Breadcrumbs2 breadcrumbs={folderPath} />
      </InlineText>
    )}
  </OptionContainer>
);
